export const lumirVData = {
  id: 24,
  createdAt: "2024-04-19T14:57:36.634Z",
  updatedAt: "2024-05-24T18:37:32.853Z",
  pageName: "Lumir-V",
  productName: "초소형 초분광 위성",
  subtitle: "Hyperspectral Small Satellite",
  language: "KR",
  fileUrl:
    "https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/2e103b7a-20ce-4210-9299-3b5f4c102563.png",
  serverFileName: "2e103b7a-20ce-4210-9299-3b5f4c102563.png",
  originFileName: "Lumir-V 1.png",
  exposure: true,
  __productContents__: [
    {
      id: 116,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.521Z",
      title: "제품 배경",
      orderNum: 1,
      productContentType: "A",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        "<p>ㆍ루미르는&nbsp;2022년&nbsp;5월&nbsp;정부의&nbsp;‘스페이스이노베이션&nbsp;사업’의&nbsp;초분광,&nbsp;가시광&nbsp;듀얼센서&nbsp;카메라를&nbsp;탑재한</p><p>초소형위성&nbsp;개발&nbsp;주관연구기관으로&nbsp;선정되었습니다.</p><p><br></p><p>ㆍ초분광&nbsp;이미징&nbsp;(HSI&nbsp;:&nbsp;Hyper-Spectral&nbsp;Imaging)은&nbsp;가시광&nbsp;및&nbsp;적외선&nbsp;영역의&nbsp;256&nbsp;주파수&nbsp;대역&nbsp;의&nbsp;측정을&nbsp;통해 대상&nbsp;물질&nbsp;고유의&nbsp;재질&nbsp;특성&nbsp;식별이&nbsp;가능합니다.</p><p><br></p><p>ㆍ이&nbsp;기술은&nbsp;의학뿐만&nbsp;아니라&nbsp;식품산업&nbsp;분야의&nbsp;머신비전&nbsp;및&nbsp;스마트팜,&nbsp;원격탐사,&nbsp;군사&nbsp;감시&nbsp;등&nbsp;일련의&nbsp;모든&nbsp;응용분야에서&nbsp;사용되고&nbsp;있으며</p><p>해외&nbsp;시장에서도&nbsp;높은&nbsp;성장률을&nbsp;보이고&nbsp;있습니다.</p><p><br></p><p>ㆍ루미르는&nbsp;산기협에서&nbsp;주관하는&nbsp;기업부설연구소&nbsp;R&amp;D역량강화&nbsp;지원사업에서&nbsp;‘초분광센서를&nbsp;이용한&nbsp;머신비전&nbsp;시스템’</p><p>과제에&nbsp;선정되었으며,&nbsp;국내에서&nbsp;전무한&nbsp;초분광&nbsp;이미징&nbsp;시장의&nbsp;국산화를&nbsp;위해&nbsp;개발&nbsp;중에&nbsp;있습니다.</p><p><br></p><p>ㆍ루미르는&nbsp;2022년&nbsp;11월&nbsp;전자통신연구원(ETRI)와&nbsp;함께&nbsp;하천의&nbsp;녹조&nbsp;감지&nbsp;등의&nbsp;목적으로&nbsp;국내&nbsp;최초로</p><p>드론용&nbsp;초분광&nbsp;카메라&nbsp;시제품을&nbsp;개발&nbsp;완료&nbsp;하였습니다. 또한&nbsp;해당&nbsp;실적들을&nbsp;통해&nbsp;현재&nbsp;누리호&nbsp;3차&nbsp;위성에&nbsp;탑재&nbsp;예정인</p><p>초소형&nbsp;초분광&nbsp;카메라&nbsp;개발에&nbsp;있어서도&nbsp;사업&nbsp;목표달성에&nbsp;지장이&nbsp;없을&nbsp;것으로&nbsp;판단하고&nbsp;있습니다.&nbsp;</p>",
      __productContentImages__: [],
    },
    {
      id: 117,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.544Z",
      title: "제품 개요",
      orderNum: 2,
      productContentType: "A",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        "<p>초분광&nbsp;카메라&nbsp;개발을&nbsp;통한&nbsp;국산화&nbsp;및&nbsp;초소형&nbsp;초분광&nbsp;위성&nbsp;설계&nbsp;및&nbsp;제작</p>",
      __productContentImages__: [],
    },
    {
      id: 118,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.566Z",
      title: "사업 실적",
      orderNum: 3,
      productContentType: "A",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        "<p>ㆍ2022.11.&nbsp;드론용&nbsp;초분광&nbsp;카메라&nbsp;전자통신연구원(ETRI)&nbsp;공동&nbsp;개발&nbsp;완료</p><p>ㆍ2022.5.&nbsp;‘스페이스이노베이션&nbsp;사업’&nbsp;연구기관&nbsp;선정</p><p>ㆍ2022.4.&nbsp;‘기업부설연구소&nbsp;R&amp;D&nbsp;과제’&nbsp;초분광센서를&nbsp;이용한&nbsp;머신비전&nbsp;시스템&nbsp;연구&nbsp;과제&nbsp;선정</p>",
      __productContentImages__: [],
    },
    {
      id: 119,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.613Z",
      title: "img1",
      orderNum: 4,
      productContentType: "C",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content: "",
      __productContentImages__: [
        {
          id: 39,
          createdAt: "2024-05-26T22:11:26.834Z",
          updatedAt: "2024-05-26T22:11:26.834Z",
          fileUrl:
            "https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/acdc6bba-5192-49e2-9955-ac3b4107edce.png",
          serverFileName: "acdc6bba-5192-49e2-9955-ac3b4107edce.png",
          originFileName: "Lumir-Vkr_01.png",
        },
      ],
    },
    {
      id: 120,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.843Z",
      title: "초분광 기술",
      orderNum: 5,
      productContentType: "B",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        '<p><strong>초분광 카메라를 탑재하는 초소형 위성 Lumir-V과 드론용 Lumir-HSC-D</strong></p><p><br></p><p>가시광 및 적외선 영역의 256 주파수 대역 측정을 통한 대상물질 고유의 재질 특성 식별</p><p><br></p><p><img src="https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/e3d29b4c-2f7e-4b72-b2fd-971b1c7e4a40.png"></p>',
      __productContentImages__: [],
    },
    {
      id: 121,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.867Z",
      title: "초분광 카메라 시험 Lumir-HSC-D",
      orderNum: 6,
      productContentType: "B",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        '<p><strong>Lumir-HSC-D초분광 카메라를 이용한 녹조 감시</strong></p><p><br></p><p>회남대교 ㅣ 주 1회 촬영 DB 구축 및 녹조 분석</p><p><br></p><p><img src="https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/647020e9-4377-4618-8605-253331e656cd.png"></p>',
      __productContentImages__: [],
    },
    {
      id: 122,
      createdAt: "2024-04-19T14:57:36.634Z",
      updatedAt: "2024-05-26T22:11:26.894Z",
      title: "초소형 Hyperspectral 위성",
      orderNum: 7,
      productContentType: "B",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        '<p><img src="https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/50a9399b-3ca7-4892-a469-44a6b22546c4.png"></p><p><br></p><p><img src="https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/9835fa18-64db-4bf9-a7dc-44ab48984646.png"></p>',
      __productContentImages__: [],
    },
    {
      id: 148,
      createdAt: "2024-05-24T18:37:33.356Z",
      updatedAt: "2024-05-26T22:11:26.918Z",
      title: "초분광 영상 활용 분야",
      orderNum: 8,
      productContentType: "B",
      fileUrl: null,
      serverFileName: null,
      originFileName: null,
      content:
        '<p><img src="https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/d469e623-637a-4b45-9efb-22cfb5e7dc2b.png"></p><p><img src="https://lumir-media.s3.ap-northeast-2.amazonaws.com/board/44b94358-babf-4e63-9527-31d50449d0ed.png"></p>',
      __productContentImages__: [],
    },
  ],
};
